export default "__VITE_ASSET__66674667__"